import { render, staticRenderFns } from "./ClassManage.vue?vue&type=template&id=7de66668&scoped=true"
import script from "./ClassManage.vue?vue&type=script&lang=js"
export * from "./ClassManage.vue?vue&type=script&lang=js"
import style0 from "./ClassManage.vue?vue&type=style&index=0&id=7de66668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de66668",
  null
  
)

export default component.exports